import { render, staticRenderFns } from "./ContentWrapperWide.vue?vue&type=template&id=3664b626"
import script from "./ContentWrapperWide.vue?vue&type=script&lang=js"
export * from "./ContentWrapperWide.vue?vue&type=script&lang=js"
import style0 from "./ContentWrapperWide.vue?vue&type=style&index=0&id=3664b626&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports